import React, { useEffect, useState } from "react";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { isDisableSubmit } from "../../../utils";
import { validationFLFContextInput } from "../../../utils/validateInput";
import { getFLFIcon } from "../../../../../apis/FLF/icon.api";

const initialValue = {
  id: "",
  name: "",
  type: "",
  colors: "",
  flfIconId: "",
};

const contextTypeOption = [
  {
    id: "script",
    name: "Script",
  },
  {
    id: "timer",
    name: "Timer",
  },
  {
    id: "auto",
    name: "Auto",
  },
  {
    id: "reverse",
    name: "Reverse",
  },
];

function FLFContextForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  const [contextIcons, setContextIcons] = useState([]);

  useEffect(() => {
    getFLFIcon(
      {
        page: 1,
        iconType: "context",
      },
      (result) => {
        setContextIcons([...result.list]);
      }
    );
  }, []);

  // validation input permission
  const validateFLFContextForm = (fieldValues = values) => {
    let temp = validationFLFContextInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFContextForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFContextForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Select
        name="type"
        label="Type"
        value={values.type}
        onChange={handleOnChange}
        options={contextTypeOption}
        error={errors.type}
      />

      {/* <Controls.ColorPickerInput
        name="colors"
        label="Colors"
        value={values.colors}
        onChange={handleInputChange}
      /> */}

      <Controls.Input
        name="colors"
        label="Colors"
        value={values.colors}
        onChange={handleOnChange}
        error={errors.colors}
      />

      {values.flfIconId !== null ? (
        <Controls.Select
          name="flfIconId"
          label="FLF Icon"
          value={values.flfIconId}
          onChange={handleOnChange}
          options={contextIcons.map((icon) => ({
            ...icon,
            name: icon.deviceName,
          }))}
          error={errors.flfIconId}
        />
      ) : null}

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFContextForm;
